import styled from '@emotion/styled';
import { LoadingIndicator } from './LoadingIndicator';

export function PageLoadingIndicator() {
  return (
    <Container>
      <LoadingIndicator />
    </Container>
  );
}

const Container = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
